<div [formGroup]="form" class="flex flex-col mr-5 h-full">

  <div class="p-4 flex align-middle">
    <app-arrow-left-button class="mr-2 mt-2" (close)="onGoToList()"></app-arrow-left-button>
    <span class="font-semibold text-xl">{{'handover.statement-header' | translate}}</span>
  </div>

  <div class="flex flex-col bg-white mx-52 mt-4 rounded-md">

    <div *ngIf="isLoading else loadedTemp" style="height: 580px" class="grid place-items-center w-full" >
      <div class="w-full grid place-items-center">
        <mat-spinner [strokeWidth]="2" [diameter]="48"></mat-spinner>
        <div class="font-semibold mt-4">{{'labels.loading-data' | translate}}</div>
      </div>
    </div>

    <ng-template #loadedTemp>
      <div class="font-semibold text-sm ml-6 mt-4 mb-1">{{'handover.statement-add' | translate}}</div>
      <div class="tk-c-gray ml-6 mb-4">{{'handover.statement-add-desc' | translate}}</div>

      <div class="px-6 rounded-lg text-black mb-6">
      <textarea 
        class="w-full rounded-lg box-border p-3  tk-border-gray-2"
        rows="25"
        [maxlength]="maxLengthRegulations"
        formControlName="text"
        [readonly]="isSaving"
        placeholder="{{'handover.statement-content' | translate}}"
      ></textarea>
      </div>
    </ng-template>

  </div>

  <div class="ml-52 mt-6 flex items-center">
    <app-button [isLoading]="isSaving" [isActive]="form.valid" innerTextClasses="mx-6" spinnerClasses="mx-8 my-2"
                label="{{'labels.save' | translate | titlecase}}" (click)="onSave()"></app-button>

    <sm-button-transparent *ngIf="!isSaving" label="{{'labels.cancel' | translate | titlecase}}" class="ml-4"
                           (click)="onCancel()">
    </sm-button-transparent>
  </div>


</div>
